export default __webpack_public_path__ + "static/media/consent_plus_team.ab30194b.png";